import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMinimize"><Path d="M3.5 10.25V3.5H21.5V15.5H14.75M13.5 8.5V11.5H16.5M17.25 7.75L13.7533 11.2467M11.5 13.5H2.5V21.5H11.5V13.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMinimize;
